import React from "react";
import { ParticipantSummary } from "../components/summary/ParticipantSummary";
import { PageSkeleton } from "../components/common/PageSkeleton";
import PreviewLayout from "../components/layouts/Preview.layout";
import { useGetParticipantSummaryByIdQuery } from "../store/participant/participant";
import { useLingui } from "@lingui/react";
import { Language } from "../types/conference.types";
import { useParticipantFromUrl } from "../hooks/useParticipantFromUrl.ts";

const ParticipantSummaryPage = () => {
  const { i18n } = useLingui();
  const registrationId = useParticipantFromUrl();
  const { data: participant, isLoading: isParticipantLoading } =
    useGetParticipantSummaryByIdQuery(registrationId);
  const showSummary = registrationId && !isParticipantLoading && participant;

  React.useEffect(() => {
    if (participant) {
      const language =
        participant.congressEvent.language === Language.ENGLISH ? "en" : "hu";
      i18n.activate(language);
    }
  }, [participant, i18n]);

  return showSummary ? (
    <PreviewLayout>
      <ParticipantSummary
        registrationId={registrationId}
        participant={participant}
      />
    </PreviewLayout>
  ) : (
    <PreviewLayout>
      <PageSkeleton />
    </PreviewLayout>
  );
};

export default ParticipantSummaryPage;
